import React from "react";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import StatusBadge from "@shared/components/application/data-display/badges/StatusBadge/StatusBadge.web";

export interface EventRestrictionsProps {
  restrictionArray: string[];
}

const EventRestrictions = ({
  restrictionArray,
}: EventRestrictionsProps): JSX.Element => {
  return (
    <Flex display="inline-block">
      {restrictionArray?.map((restriction: string) => (
        <Flex key={restriction} mt="xs" mr="xs" display="inline-block">
          <StatusBadge status="info">{restriction}</StatusBadge>
        </Flex>
      ))}
    </Flex>
  );
};

export default EventRestrictions;
